import React from 'react'
import "../trinetra.css"
import { useNavigate } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';


export default function FooterWeb() {

    const navigate = useNavigate()
    const backButton = () => {
        // console.log ("button click");
        // navigate(-1);
      }
      
  return (
        <div className='footer-container'>
        <div className='footer'>
            <div className='copyright float'>
                <span> Copyright © 2023 ThirdEye AI.  All rights reserved. </span>
            </div>
            <div className='copyright-link float'>
                <a href='#'>Privacy Policy</a>
                <a href='#'>Terms & Condition</a>
                <a href='#'>About Us</a>
                <a href='#'>Contact Us</a>
            </div>
        </div>
      </div>
  )
}
